import React, { useState } from "react";
import { Modal, Button, Form, Col, Row } from "react-bootstrap";

function InstallmentModal({
  show,
  handleClose,
  beneficiary,
  onAddInstallment,
}) {
  const [installment, setInstallment] = useState("");
  const [amount, setAmount] = useState("");

  const availableInstallments = [1, 2, 3, 4, 5].filter(
    (inst) => !beneficiary.installments[inst]
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!installment || !amount) {
      alert("Please select an installment and enter an amount.");
      return;
    }
    onAddInstallment(beneficiary.id, installment, parseFloat(amount));
    setInstallment("");
    setAmount("");
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add Installment for {beneficiary.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <p>
            <strong>Beneficiary Code:</strong> {beneficiary.beneficiaryCode}
          </p>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>
                  <strong>Select Installment</strong>
                </Form.Label>
                <Form.Select
                  value={installment}
                  onChange={(e) => setInstallment(e.target.value)}
                  required
                >
                  <option value="">Choose...</option>
                  {availableInstallments.map((inst) => (
                    <option key={inst} value={inst}>
                      {inst}
                      {inst === 1
                        ? "st"
                        : inst === 2
                        ? "nd"
                        : inst === 3
                        ? "rd"
                        : "th"}{" "}
                      Installment
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>
                  <strong>Amount</strong>
                </Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Enter amount"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="d-flex justify-content-end mt-3">
            <Button variant="secondary" onClick={handleClose} className="me-2">
              Cancel
            </Button>
            <Button
              variant="success"
              type="submit"
              disabled={availableInstallments.length === 0}
            >
              {availableInstallments.length > 0
                ? "Add Installment"
                : "All Paid"}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default InstallmentModal;
